import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IPropertySearchCriteria } from '../models/propertysearchcriteria';
import { ResultOutputModel } from '../models/resultOutputModel';
import { IPageStatusModel } from '../models/PageStatusModel';
import { BehaviorSubject, Observable } from 'rxjs';
import { IPropertyCard, DefaultTickers } from '../models/propertycard';
import { SaveAnalyticsInputModel } from '../models/SavePropertyAnalyitcsInputModel';
import { DealTeamInput } from '../models/DealTeamInput';
import { IImageList, IPropertyDetails } from '../models/propertydetails';
import { SavePropertyAccessLogModel } from '../models/SavePropertyAccessLogModel';
import { ISaveSearchInputModel } from '../models/SaveSearchInputModel';
import { IDocumentAccessInputModel } from '../models/DocumentAccessInputModel';
import { IDocumentAccessOutputModel } from '../models/DocumentAccessOutputModel';
import { IPropertyRentTermModel } from '../models/PropertyRentTermModel';
import { SharePropertyEmailInputModel } from '../models/SharePropertyEmailInputModel';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../auth/authentication.service';
import { BrowserService } from '../../shared/browser-service.service';
import { IShareReportModel } from '../models/IShareRportModel';
import { DocumentOutputModel } from '../models/SavePropertyInputModel';
import { AuthService } from '../auth/auth.service';
import { ToastService } from './toast.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PortfolioContactInput } from '../models/PortfolioContactInput';
import { PortfolioContactDetails } from '../models/PortfolioContactDetails';
import { DocumentOutputModel as DocumentOutputModelOfDES } from '../../shared/models/DataEntryStaffPropertyListOutputModel';
import { IImportProspectInputModel } from '../models/ImportProspectInputModel';



@Injectable({
  providedIn: 'root'
})
export class PropertyListingService extends RestService {
  constructor(protected http: HttpClient, private Authentication: AuthenticationService,
    private browserService: BrowserService, public router: Router, public Auth0: AuthService, public authService: AuthenticationService, private _toastService: ToastService,) {
    super(http);
  }

  public criteria = {} as IPropertySearchCriteria;
  public selectedBrokerage: number[];
  public selectedPropetyStatus: number[];
  public fromHome: boolean = false;
  savedSearchResponse = {} as ResultOutputModel;
  public currentView: number = 1;
  public showDisLike: boolean = false;
  public activePropertyTab: any;
  private saveSearchClick = new BehaviorSubject<boolean>(false);
  PageStatusModel = {} as IPageStatusModel;
  saveSearchUpdateStatus = this.saveSearchClick.asObservable();
  //public fillPrevSearchCriteria: boolean = false;
  UpdateSaveSearch(value: boolean) {
    this.saveSearchClick.next(value);
  }

  // Get the list of properties
  getPropertyListing(searchParameters: IPropertySearchCriteria) {
    return this.post<IPropertyCard>('property', searchParameters);
  }

  getPropertyListingCount(searchParameters: IPropertySearchCriteria) {
    return this.post('property/PropertyListCount', searchParameters);
  }

  // Get the list of Properties For Analytics
  GetPropertiesForAnalytics(searchParameters: IPropertySearchCriteria) {
    return this.post<any>('property/PropertiesForAnalytics', searchParameters);
  }

  GetCompProperties(searchParameters: IPropertySearchCriteria) {
    return this.post<any>('property/comps-list', searchParameters);
  }

  GetAllImportProspect(importProspectInputModel: IImportProspectInputModel) {
    return this.post<any>('property/allImportProspectList/', importProspectInputModel);
  }

  // Get the list of Properties For Analytics
  GetPropertyInfoForAnalytics(propertyId, isExport) {
    return this.post('property/PropertyInfoForAnalytics/' + isExport, propertyId);
  }

  saveAnalytics(saveAnalytics: SaveAnalyticsInputModel, userId: number): Observable<boolean> {
    return this.postForEntityObject('analytics/SaveAnalytics/' + userId, saveAnalytics);
  }

  addDealTeam(dealTeam: DealTeamInput): Observable<boolean> {
    return this.postForEntityObject('property/adddealcontacts/', dealTeam);
  }

  deleteDealTeam(dealTeamId: number, propertyId: number) {
    return this.GET('property/deletedealcontact/' + dealTeamId + '/' + propertyId);
  }

  addPortfolioContact(dealTeam: PortfolioContactInput): Observable<boolean> {
    return this.postForEntityObject('dataentryproperty/addportfoliocontact/', dealTeam);
  }

  PortfolioContactDetails(analyzeId: number): Observable<PortfolioContactDetails> {
    return this.get<PortfolioContactDetails>('dataentryproperty/getportfoliocontact/' + analyzeId);
  }

  deletePortfolioContact(dealTeamId: number, loggedInUserId: number) {
    return this.GET('dataentryproperty/deleteportfoliocontact/' + dealTeamId + '/' + loggedInUserId);
  }
  deletepropertyDetailsContact(dealTeamId: number, loggedInUserId: number, propertyId: number) {
    return this.GET('dataentryproperty/deletepropertyDetailsContact/' + dealTeamId + '/' + loggedInUserId + '/' + propertyId);
  }

  updateIsPortfolio(id: number, isPortfolio: boolean, loggedInUser: number) {
    return this.GET('dataentryproperty/updateisportfolio/' + id + '/' + isPortfolio + '/' + loggedInUser);
  }

  // Get the list of properties for tabular view
  getPropertyListingAsDataTable(searchParameters: IPropertySearchCriteria) {
    return this.post<IPropertyCard>('property/propertieslistview', searchParameters);
  }

  // Get the list of tenants
  getTenants() {
    return this.GET('common/tenants');
  }

  // Get the list of saved analytics
  getSavedAnalytics(userId: number) {
    return this.GET('analytics/SavedAnalytics/' + userId);
  }

  // Get the list of saved analytics
  deleteSavedAnalytics(guid: string) {
    return this.get<boolean>('analytics/DeleteSavedAnalytics/' + guid);
  }

  // Get the list of saved analytics
  deletePortfolioSavedAnalytics(id: number) {
    return this.get<boolean>('dataentryproperty/DeletePortfolioSavedAnalytics/' + id);
  }

  // Get the list of saved analytics search
  getSavedAnalyticsSearch(id: string): Observable<SaveAnalyticsInputModel> {
    return this.get('analytics/SavedSearchForAnalytics/' + id);
  }

  // Get the list of History dates for status change
  propertyhistoryfortimeline(id: number) {
    return this.GET('property/propertyhistoryfortimeline/' + id);
  }

  // Get all principal portfolio property
  getAllPrincipalPortfolioProperty(userid: number, userGuid: string) {
    return this.GET('dataentryproperty/getAllPrincipalPortfolioProperty/' + userid + '/' + userGuid);
  }

  // generate Report
  generateReport(shareReportInputModel) {
    return this.postForEntityObject('property/generateReport/', shareReportInputModel);
  }

  // generate Report
  generateExchange1031(exchangeId: number, loggedInUserId: number, OffsetTime: number, exchangeGuid: string) {
    return this.GET('property/generateExchange1031Report/' + exchangeId + '/' + loggedInUserId + '/' + OffsetTime + '/' + exchangeGuid);
  }

  // Share Report
  shareReport(saveSearchInputModel): Observable<string> {
    return this.postForEntityObject('property/shareReport/', saveSearchInputModel);
  }

  // Get the list of terms
  getTerms() {
    return this.GET('common/terms');
  }

  // Get the property details by Guid
  getPropertyDetails(id: string, userId: number, isFromMessages = false, isDashboardEnabled = false) {
    if (userId == undefined)
      userId = 0;
    return this.postForEntityObject<IPropertyDetails>('property/details/' + id + '/' + userId + '/' + isFromMessages + '/' + isDashboardEnabled, '');
  }

  // Get the property details by Guid
  getDataEntryPropertyDetails(id: string, userId: number) {
    if (userId == undefined)
      userId = 0;
    return this.postForEntityObject<IPropertyDetails>('dataentryproperty/details/' + id + '/' + userId, '');
  }

  //save Property Access Log for principal
  savePropertyAccessLog(savePropertyAccessLogModel: SavePropertyAccessLogModel): Observable<boolean> {
    return this.postForEntityObject('property/savePropertyAccessLog/', savePropertyAccessLogModel);
  }

  // delete saved search by Guid
  deleteSavedSearch(guid: string) {
    return this.post('property/deletesavesearch/' + guid, '');
  }

  // contact broker
  contactBroker(userId: number, propertyId: number) {
    return this.get('dataentryproperty/assignbrokeremailtrigger/' + userId + '/' + propertyId);
  }

  // contact broker
  SendPropertyAccessRequest(userId: number, propertyId: number, userGuid: string, source: string) {
    return this.get('dataentryproperty/addPropertyAccessToUserMail/' + userId + '/' + propertyId + '/' + userGuid + '/' + source);
  }

  Send1031AccessRequest(userId: number, propertyId: number, source: string) {
    return this.get('dataentryproperty/add1031accesstousermail/' + userId + '/' + propertyId + '/' + source);
  }

  getRequestedProperties(userId: number, tenantId, userGuid: string) {
    return this.GET('dataentryproperty/getavailableandoffmarketproperties/' + userId + '/' + tenantId + '/' + userGuid);
  }

  ContactBovBroker(userId: number, userGuid: string) {
    return this.get('dataentryproperty/contactBovBroker/' + userId + '/' + userGuid);
  }

  // Save user searches
  saveSearch(saveSearchInputModel: ISaveSearchInputModel): Observable<ResultOutputModel> {
    return this.postForEntityObject('property/savesearch/', saveSearchInputModel);
  }

  // Get the Use rsaved Search
  getUsersavedSearch(userid: number) {
    return this.post('property/usersavedsearches/' + userid, '');
  }

  // Get the User Saved Search Criteria
  getUserSavedSearchCriteria(guid: string) {
    return this.postForEntityObject('property/savedsearchcriteria/' + guid, '');
  }

  // Get the document access request setting
  getAccessRequestForDocuments(docAccessRequestInputModel: IDocumentAccessInputModel) {
    return this.postForEntityObject<IDocumentAccessOutputModel>('property/documentaccesssetting', docAccessRequestInputModel);
  }

  // Save the document access request setting
  saveAccessRequestForDocuments(docAccessRequestInputModel: IDocumentAccessOutputModel) {
    return this.postForEntityObject('property/savedocumentaccesssetting', docAccessRequestInputModel);
  }

  getDueDiligenceDocuments(id: number) {
    return this.postForEntityObject<DocumentOutputModel[]>('property/GetDueDiligenceDocuments/' + id, '');
  }

  // Save the document access request setting
  deleteProperty(guid: string, userId: number) {
    return this.post('property/delete/' + guid + '/' + userId, '');
  }

  deleteDataEntryProperty(guid: string, userId: number) {
    return this.post('property/deleteDataEntryProperty/' + guid + '/' + userId, '');
  }

  requestDuplicatePropertyEdit(editRequest) {
    return this.post('property/RequestDuplicatePropertyEdit/', editRequest);
  }


  requesteditproperty(editRequest) {
    return this.post('property/RequestEditProperty/', editRequest);
  }

  getrequestdetail(propertyId: string, userGuid: string) {
    return this.get('property/GetRequestDetails/' + propertyId + '/' + userGuid);
  }

  // Get the Similar Properties details by property id
  GetSimilarProperties(id: number, userId: number) {
    if (userId == undefined)
      userId = 0;
    return this.GET('property/SimilarProperties/' + id + '/' + userId);
  }

  // Get the Document Count
  GetDocumenAccessRequestListCount(propertyId: number, userId: number) {

    if (userId == undefined)
      userId = 0;
    return this.GET('property/documentaccessrequestscount/' + propertyId + '/' + userId);
  }
  GetPropertiesOfDataEntryStaffCount(brokerageId: number, userId: number) {
    if (userId == undefined)
      userId = 0;
    return this.GET('property/getpropertiesofdataentrystaffcount/' + brokerageId + '/' + userId);
  }

  GetDocumentsOfPropertiesOfDataEntryStaff(documentInputModel) {
    return this.postForEntityObject<DocumentOutputModelOfDES[]>('property/dataentrypropertydocumentlist/', documentInputModel);
  }

  // Share Property through Mail
  shareProperty(mailPropertyDetails: SharePropertyEmailInputModel) {
    return this.postForEntityObject('property/SharePropertyMail', mailPropertyDetails);
  }

  // Share Property through LinkedIn
  sharePropertyLinkedIn(PropertySharedData) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-li-format': 'json',
        'Authorization': 'Bearer AQXjz8mrzKj8QAiaJL5CyrwB2JRWt8aMT2aCUQ5Q206P_R1QGXbCvyIlPRgtk3GvOb5djxKnKLhOGvsDnLX4VnxXzUS178rPLUUBdcBV3NhP39Iyj4uVg4_u89NA58G5mVmBaiyMO7c3QaBbJsNiNmzF0qJSuJyJCXvHc30_lSZkGsxJJoP_yN8xqwAaZNV1XzSRol3QlHLkXvj7w_H2bzmXw0hy53fnYQWdrV7h_upiYNAY9mYzexgWdhEwy6oiRY0KfvQZewBLCh1kBX_MZ1HDflTJGY0wc-6FBzS6xp4tRPaUSvi88uOslWEtjyO4y_IQgCL0OlZv82jq99Hyvlb2wJUV-Q'
      })
    }
    return this._http.post('https://api.linkedin.com/v1/people/~/shares?format=json', PropertySharedData, httpOptions);
  }

  BulkStatusChange(status: number, propertyId: any, loggedinUserId: number) {
    return this.postForEntityObject('property/BulkStatusChange/' + status + "/" + loggedinUserId, propertyId);
  }

  BulkStatusChangeWithComments(ChangePropertyStatusmodel: any) {
    return this.postForEntityObject('property/ChangePropertyStatus/', ChangePropertyStatusmodel);
  }

  // Get the list of tenants
  getTrackingCode() {
    return this.GET('common/GetTrackingCode');
  }


  GetRemainingTerm(propertyId: number) {
    return this.GET('property/remainingterm/' + propertyId);
  }

  // Get the property details by Guid
  GetPropertyRentTermTable(propertyGuid: number) {
    return this.postForEntityObject<IPropertyRentTermModel[]>('property/getPropertyRentTermTable/' + propertyGuid, '');
  }
  GetDataEntryPropertyRentTermTable(propertyGuid: number) {
    return this.postForEntityObject<IPropertyRentTermModel[]>('dataentryproperty/getDataEntryPropertyRentTermTable/' + propertyGuid, '');
  }

  GetCurrentView() {
    if (!this.browserService.document) {
      return;
    }
    this.PageStatusModel = JSON.parse(localStorage.getItem("PageStatus"));
    if (this.PageStatusModel) {
      this.currentView = this.PageStatusModel.View
    }
    if (this.currentView == null) {
      this.currentView = 1;
    }
    return this.currentView;
  }
  GetPortfolioPropertiesList(searchParameters: IPropertySearchCriteria) {
    return this.post<any>('property/propertyListForPortfolio', searchParameters);
  }
  GetPrincipalPortfolioList(propertyId) {
    return this.GET('property/myPortfolioPropertyList/' + propertyId);
  }

  GetPortfolioPropertyListForMyPortfolio(propertyId, userId) {
    return this.GET('property/propertyListformyportfolio/' + propertyId + '/' + userId);
  }

  GetPortfolioPropertiesListByIds(searchParameters: IPropertySearchCriteria) {
    return this.post<any>('property/propertyListForPortfolioByIds', searchParameters);
  }

  GetSellerDashboardSummary(sellerId: number, userId: number) {
    return this.GET('property/sellerdashboardsummary/' + sellerId + "/" + userId);
  }

  GetOfferComparison(sellerId: number, propertyId: number, userId = 0, period: number) {
    return this.GET('property/propertyOffersfordashboard/' + sellerId + "/" + propertyId + "/" + userId + "/" + period);
  }

  GetLeadsCoversionRatio(propertyId: number, period: number) {
    return this.GET('property/propertyprospectsLOIratio/' + propertyId + "/" + period);
  }

  GetSellerMarketingPerformance(sellerId: number, propertyId: number, userId = 0, period: number) {
    return this.GET('property/sellermarketingperformance/' + sellerId + "/" + propertyId + "/" + userId + "/" + period);
  }

  GetSellerPropertyForDropdown(sellerId: number, userId: number) {
    return this.GET('property/sellerpropertylist/' + sellerId + '/' + userId);
  }

  GetDealContacts(propertyId: number) {
    return this.GET('property/dealcontacts/' + propertyId);
  }

  GetPortfolioContacts(userId: number) {
    return this.GET('dataentryproperty/portfoliocontacts/' + userId);
  }

  GetSellerDealsPortfolioList(propertyIds) {
    return this.post('property/sellerdealsportfoliolist/', propertyIds);
  }

  GetDispositionTimeline(sellerid: number, userId: number) {
    return this.GET('property/dispositiontimeline/' + sellerid + "/" + userId);
  }

  GetDefaultTickers(sellerId) {
    return this.get<DefaultTickers[]>('property/defaultTickers/' + sellerId);
  }
  GetProspectsDetails(userId: number) {
    return this.GET('user/principalProspects/' + userId);
  }
  GetPrincipal1031ExchangeDetails(userId: number) {
    return this.GET('user/principal1031ExchangeDetails/' + userId);
  }
  RemoveTickers(tickerId) {
    return this.postForEntityObject('property/removeTickers/', tickerId);
  }
  ChangePrincipalProspectStatus(propertyGuid: string) {
    return this.postForEntityObject('property/changePrincipalProspectStatus/', propertyGuid);
  }
  GetTickerSymbols(sellerid: number) {
    return this.GET('property/tickersymbols/' + sellerid);
  }
  GetDealCalendar(sellerid: number, userId: number) {
    return this.GET('property/dealCalendar/' + sellerid + '/' + userId);
  }
  AssignBrokerToBovRequest(bovid: number, brokerid: number, propertyId: number) {
    return this.GET('property/assignbrokertobovrequest/' + bovid + "/" + brokerid + "/" + propertyId);
  }
  AssignBrokerToProperty(brokerid: number, propertyId: number) {
    return this.GET('dataentryproperty/assignbrokertoproperty/' + brokerid + "/" + propertyId);
  }
  GetBOVStatusCount(userId: number, loggedInUserId: number) {
    return this.GET('property/BOVStatusCount/' + userId + '/' + loggedInUserId);
  }
  GetOffMarketApprovalStatusCount() {
    return this.GET('dataentryproperty/OffMarketApprovalStatusCount/');
  }
  ChangeInquiryStatus(bovid: number, statusid: number, userId: number) {
    return this.GET('property/changebovstatus/' + bovid + '/' + statusid + "/" + userId);
  }
  RejectOffMarketApproval(dataentrypropertyid: number) {
    return this.GET('dataentryproperty/rejectoffmarketapproval/' + dataentrypropertyid);
  }
  ChangeApprovalStatus(dataentrypropertyid: number, statusid: number) {
    return this.GET('dataentryproperty/changeapprovalstatus/' + dataentrypropertyid + '/' + statusid);
  }
  GetStockNews(tickers, count) {
    let stockNewsAPIToken = environment.stockNewsAPIToken;
    return this._http.get('https://stocknewsapi.com/api/v1?tickers=' + tickers + '&items=' + count + '&token=' + stockNewsAPIToken);
  }
  GetStockGeneralNews(count) {
    let stockNewsAPIToken = environment.stockNewsAPIToken;
    return this._http.get('https://stocknewsapi.com/api/v1/category?section=general&items=' + count + '&sentiment=positive&token=' + stockNewsAPIToken);
  }
  GetStockValues(tickers) {
    let rapidapihost = environment.rapidapihost;
    let rapidapikey = environment.rapidapikey;
    const httpOptions = {
      headers: new HttpHeaders({
        'x-rapidapi-host': rapidapihost,
        'x-rapidapi-key': rapidapikey
      })
    }
    return this._http.get('https://apidojo-yahoo-finance-v1.p.rapidapi.com/market/v2/get-quotes?region=US&symbols=' + tickers, httpOptions);
  }

  GetStockProfile(ticker) {
    let rapidapihost = environment.rapidapihost;
    let rapidapikey = environment.rapidapikey;
    const httpOptions = {
      headers: new HttpHeaders({
        'x-rapidapi-host': rapidapihost,
        'x-rapidapi-key': rapidapikey
      })
    }
    return this._http.get('https://apidojo-yahoo-finance-v1.p.rapidapi.com/stock/get-fundamentals?region=US&symbol=' + ticker + '&lang=en-US&modules=assetProfile', httpOptions);
  }

  GetTickerSymbolsAutocomplete(tenantName) {
    let rapidapihost = environment.rapidapihost;
    let rapidapikey = environment.rapidapikey;
    const httpOptions = {
      headers: new HttpHeaders({
        'x-rapidapi-host': rapidapihost,
        'x-rapidapi-key': rapidapikey
      })
    }
    return this._http.get('https://apidojo-yahoo-finance-v1.p.rapidapi.com/market/auto-complete?lang=en&region=US&query=' + tenantName, httpOptions);
  }

  GetTickerChart(symbol, interval, range) {
    let rapidapihost = environment.rapidapihost;
    let rapidapikey = environment.rapidapikey;
    const httpOptions = {
      headers: new HttpHeaders({
        'x-rapidapi-host': rapidapihost,
        'x-rapidapi-key': rapidapikey
      })
    }
    return this._http.get('https://apidojo-yahoo-finance-v1.p.rapidapi.com/market/get-charts?interval=' + interval + '&symbol=' + symbol + '&range=' + range + '&lang=en&region=US', httpOptions);
  }

  GetSummaryDetails(symbol) {
    let rapidapihost = environment.rapidapihost;
    let rapidapikey = environment.rapidapikey;
    const httpOptions = {
      headers: new HttpHeaders({
        'x-rapidapi-host': rapidapihost,
        'x-rapidapi-key': rapidapikey
      })
    }
    return this._http.get('https://apidojo-yahoo-finance-v1.p.rapidapi.com/stock/get-fundamentals?region=US&symbol=' + symbol + '&lang=en-US&modules=calendarEvents%2CsummaryDetail', httpOptions);
  }

  GetStatitics(symbol) {
    let rapidapihost = environment.rapidapihost;
    let rapidapikey = environment.rapidapikey;
    const httpOptions = {
      headers: new HttpHeaders({
        'x-rapidapi-host': rapidapihost,
        'x-rapidapi-key': rapidapikey
      })
    }
    return this._http.get('https://apidojo-yahoo-finance-v1.p.rapidapi.com/stock/get-fundamentals?region=US&symbol=' + symbol + '&lang=en-US&modules=financialData%2CsummaryDetail%2CfundProfile%2CcalendarEvents%2CdefaultKeyStatistics', httpOptions);
  }

  GetFinancialsForAnnual(symbol, p1, p2, type) {
    let rapidapihost = environment.rapidapihost;
    let rapidapikey = environment.rapidapikey;
    const httpOptions = {
      headers: new HttpHeaders({
        'x-rapidapi-host': rapidapihost,
        'x-rapidapi-key': rapidapikey
      })
    }
    return this._http.get('https://apidojo-yahoo-finance-v1.p.rapidapi.com/stock/v2/get-timeseries?symbol=' + symbol + '&region=US&period1=' + p1 + "&period2=" + p2 + "&type=" + type, httpOptions);
  }
  GetFinancials(symbol) {
    var d = new Date();
    var year = d.getFullYear();
    var month = d.getMonth();
    var day = d.getDate();
    var dateBefore1yr = new Date(year - 4, month, day);
    var p1 = Number(dateBefore1yr.getTime() / 1000).toFixed(0);
    var p2 = Number(new Date().getTime() / 1000).toFixed(0);
    symbol = 'AAPL';
    //var p2 = '1737417600';
    //var p1 = '1611100800'
    var type = 'trailingTotalRevenue,trailingCostOfRevenue,trailingGrossProfit,trailingSellingGeneralAndAdministration,trailingResearchAndDevelopment,trailingOperatingExpense,trailingOperatingIncome,trailingInterestExpense,trailingOtherIncomeExpense,trailingPretaxIncome,trailingTaxProvision,trailingNetIncomeContinuousOperations,trailingNetIncomeCommonStockholders,trailingBasicEPS,trailingDilutedEPS,trailingBasicAverageShares,trailingEBITDA,trailingDilutedAverageShares,annualEBITDA,annualTotalRevenue,annualCostOfRevenue,annualGrossProfit,annualSellingGeneralAndAdministration,annualResearchAndDevelopment,annualTotalOperatingExpenses,annualOperatingIncome,annualInterestExpense,annualOtherIncomeExpenseNet,annualPretaxIncome,annualIncomeTaxPayable,annualNetIncomeFromContinuingOps,annualNetIncome,annualNetIncomeCommonStockholders,annualBasicEPS,annualDilutedEPS,annualBasicAverageShares,annualDilutedAverageShares,trailingNetIncome'
    let rapidapihost = environment.rapidapihost;
    let rapidapikey = environment.rapidapikey;
    const httpOptions = {
      headers: new HttpHeaders({
        'x-rapidapi-host': rapidapihost,
        'x-rapidapi-key': rapidapikey
      })
    }
    return this._http.get('https://apidojo-yahoo-finance-v1.p.rapidapi.com/stock/v2/get-timeseries?symbol=' + symbol + '&region=US&period1=' + p1 + "&period2=" + p2 + "&type=" + type, httpOptions);
  }

  GetTimeSeries(symbol) {
    var d = new Date();
    var year = d.getFullYear();
    var month = d.getMonth();
    var day = d.getDate();
    var dateBefore1yr = new Date(year - 1, month, day);
    let rapidapihost = environment.rapidapihost;
    let rapidapikey = environment.rapidapikey;
    const httpOptions = {
      headers: new HttpHeaders({
        'x-rapidapi-host': rapidapihost,
        'x-rapidapi-key': rapidapikey
      })
    }
    var p1 = Number(dateBefore1yr.getTime() / 1000).toFixed(0);
    var p2 = Number(new Date().getTime() / 1000).toFixed(0);
    return this._http.get('https://apidojo-yahoo-finance-v1.p.rapidapi.com/stock/v2/get-timeseries?symbol=' + symbol + '&region=US&period1=' + p1 + "&period2=" + p2, httpOptions);
  }



  saveTickerSymbolsForAUser(input) {
    return this.postForEntityObject('property/saveTickerSymbolsForAUser/', input);
  }

  SaveBOVRequest(input) {
    return this.postForEntityObject('property/SaveBOVRequest/', input);
  }
  SavePortfolioBov(input) {
    return this.postForEntityObject('property/RequestBov/', input);
  }

  GetBOVRequestDetails(guid) {
    return this.get('property/BOVRequestDetails/' + guid);
  }

  GetPortfolioOfferComparison(propertyId: number) {
    return this.GET('opportunity/PortfolioOfferComparison/' + propertyId);
  }

  GetPortfolioProperties(propertyId: number) {
    return this.GET('property/GetPortfolioProperty/' + propertyId);
  }

  ApproveTenantAndGuarantor(propertyId: number) {
    return this.GET('dataentryproperty/approveTenantAndGuarantor/' + propertyId);
  }

  GetDataentryPortfolioPropertiesList(searchParameters: IPropertySearchCriteria) {
    return this.post<any>('dataentryproperty/dataentyrpropertyListForPortfolio', searchParameters);
  }

  dataEntryStaffPropertyListByPortfolioId(portfolioId) {
    let user: any = this.Authentication.user;
    return this.post<any>('dataentryproperty/dataEntryStaffPropertyListByPortfolioId/' + user.Id + '/' + portfolioId, null);
  }

  GetPortfolioSummary(loggedInUserId: number, userGuid: string) {
    return this.GET('dataentryproperty/getportfoliosummary/' + loggedInUserId + '/' + userGuid);
  }

  GetOtherUserPortfolio(loggedInUserId: number, UserGuid: string) {
    return this.GET('property/getOtherUserPortfolio/' + loggedInUserId + '/' + UserGuid);
  }

  CheckMyportfolioAccess(userId: number) {
    return this.get("user/CheckMyportfolioAccess/" + userId);
  }

  CopyPropertyToDE(propertyId) {
    return this.GET('property/copyPropertyToDE/' + propertyId);
  }

  GetPropertyDetailsForMerge(propertyIds: any) {
    return this.post('property/GetPropertyDetailsForMerge', propertyIds);
  }

  MergeProperties(MergeProperties) {
    return this.post<any>('property/MergeProperties', MergeProperties);
  }

  getMatchingListings(prospectId) {
    return this.GET('salesforce/matchinglisting/' + prospectId);
  }

  LinkPortfolio(prospectId, propertyId) {
    return this.GET('salesforce/LinkPortfolio/' + prospectId + '/' + propertyId);
  }

  GetPropertyDD(id) {
    return this.get('property/GetPropertyDDDocuments/' + id);
  }

  logout() {
    this.authService.logoutClicked = true;
    $("body").removeClass("open-sidemenu");
    window.scrollTo(0, 0);
    if (this.authService.isAuth0Enabled) {
      this.Auth0.IsLogOut = true;
      this.Auth0.logout();
    }
    else {
      this.authService.logout();
      this.router.navigate(['/']);
    }
    this._toastService.addToast({ title: 'Unauthorized Action', msg: "Terms and Conditions have been updated. Kindly login and accept", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
  }

  // Get the list of tenants
  getPrincipalProperties(tenantId: number, userId: number, UserGuid: string) {
    return this.GET('property/GetPrincipalProperties/' + tenantId + '/' + userId + '/' + UserGuid);
  }

  getPrincipalHighlight(tenantId: number, userId: number, UserGuid: string) {
    return this.GET('property/GetPrincipalHighlight/' + tenantId + '/' + userId + '/' + UserGuid);
  }

  GetnotificationFilterProperties(searchText) {
    return this.GET('property/propertiesByAutocomplete/' + searchText);
  }

}
